module.exports = __webpack_public_path__ + "static/media/contact.66869a8e.png";